<script setup>
/* eslint-disable */
import { onMounted, onBeforeUnmount, watch, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { usePreSportsStore } from '@/stores/pre_sports';
import { useLiveSportsStore } from '@/stores/live_sports';
import { useMarketsStore } from '@/stores/markets';
import { useInitializeStore } from '@/stores/initialize';
import EsportFixtureDoubleMarket from '@/components/esports/highlights/EsportFixtureDoubleMarket.vue';
import LiveFixtureDoubleMarket from '@/components/esports/highlights/LiveFixtureDoubleMarket.vue';
import { SportsData } from '@/stores/Sports';
import { useCompetitionsStore } from '@/stores/competitions';
import { useFavouritesStore } from '@/stores/favourites';

const router = useRouter();
const preSportsStore = usePreSportsStore();
const liveSportsStore = useLiveSportsStore();
const initializeStore = useInitializeStore();
const marketsStore = useMarketsStore();
const SportsDataStore = SportsData();
const competitionsStore = useCompetitionsStore();
const favouritesStore = useFavouritesStore();

const show_primary_overview_market = ref(false);
const show_secondary_overview_market = ref(false);

const primary_overview_market = ref(null);
const secondary_overview_market = ref(null);

const props = defineProps({
	competition: {
		type: Object,
		required: true,
	},
});

const selectPrimaryOverviewMarket = (overview_market) => {
	primary_overview_market.value = overview_market;
	show_primary_overview_market.value = false;
}

const selectSecondaryOverviewMarket = (overview_market) => {
	secondary_overview_market.value = overview_market;
	show_secondary_overview_market.value = false;
}

const closePrimaryOverviewMarketSelector = () => {
	show_primary_overview_market.value = false;
}

const closeSecondaryOverviewMarketSelector = () => {
	show_secondary_overview_market.value = false;
}



</script>

<template>
	<div class="live-bet-dashboard competetion-main round-games-main set_game-outer">
		<div class="bet-dashboard-top">
			<div class="tabing-dashboard">
				<div class="competition-tab-title">
					<div class="country-flag">
						<img :src="'/assets' + competition.region_icon_url" alt="country-flag">
					</div>
					<h6> {{ competition.region_name }} - {{ competition.competition_name }} </h6>
				</div>
			</div>

			<!-- <div class="dashboard-info-label dropdown-option-top" v-if="primary_overview_market">
				<div class="select-option">
					<dl class="drop" :class="show_primary_overview_market ? 'active' : ''">
						<span class="tabIco">
							<svg xmlns="http://www.w3.org/2000/svg" width="4" height="3" viewBox="0 0 4 3">
								<g id="Group_73" data-name="Group 73" transform="translate(-134 -568)">
									<path id="Polygon_2" data-name="Polygon 2" d="M2,0,4,3H0Z" transform="translate(138 571) rotate(180)" fill="var(--white)" />
								</g>
							</svg>
						</span>
							<dt style="display: flex; align-items: center; justify-content: space-between; padding-right: 15px;">
								<button class="tablinks" style="flex-grow: 1; text-align: left;" @click="show_primary_overview_market = !show_primary_overview_market"  v-click-outside-element="closePrimaryOverviewMarketSelector">{{ primary_overview_market.name.toUpperCase() }}</button>
							</dt>
						<dd>
								<ul>
									<li v-for="overview_market in marketsStore.sportOverviewMarkets(preSportsStore.selected_esport_id)" :key="overview_market.slug" @click="selectPrimaryOverviewMarket(overview_market)" :class="primary_overview_market.slug == overview_market.slug ? 'active' : ''" style="display: flex; justify-content: space-between; align-items: center; padding-right: 15px;">
										<button class="tablinks" style="flex-grow: 1; text-align: left;">{{ overview_market.name.toUpperCase() }}</button>
										<div class="live-fav-icon" style="cursor: pointer; padding-left: 10px; display: flex; align-items: center;" @click.stop="favouritesStore.toggleFavouriteOverviewMarket(preSportsStore.selected_esport_id, overview_market)">
											<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 12 11.143">
												<path :style="{ fill: favouritesStore.isOverviewFavourite(preSportsStore.selected_esport_id, overview_market) ? 'var(--primary)' : 'var(--tab-gray)' }" id="Icon_ionic-ios-star" data-name="Icon ionic-ios-star" d="M12.67,5.545H8.729l-1.2-3.573a.434.434,0,0,0-.814,0l-1.2,3.573H1.554a.43.43,0,0,0-.429.429.315.315,0,0,0,.008.072.412.412,0,0,0,.179.3L4.551,8.63,3.308,12.244a.43.43,0,0,0,.147.482.414.414,0,0,0,.241.1.525.525,0,0,0,.268-.1l3.161-2.253,3.161,2.253a.5.5,0,0,0,.268.1.385.385,0,0,0,.238-.1.425.425,0,0,0,.147-.482L9.7,8.63l3.212-2.3.078-.067a.449.449,0,0,0,.139-.287A.454.454,0,0,0,12.67,5.545Z" transform="translate(-1.125 -1.688)" />
											</svg>
										</div>
									</li>
								</ul>
						</dd>
					</dl>
				</div>
			</div> -->

			<!-- <div class="dashboard-info-label dropdown-option-top dropdown-option-top-2" v-if="secondary_overview_market">
				<div class="select-option">
					<dl class="drop" :class="show_secondary_overview_market ? 'active' : ''">
						<span class="tabIco">
							<svg xmlns="http://www.w3.org/2000/svg" width="4" height="3" viewBox="0 0 4 3">
								<g id="Group_73" data-name="Group 73" transform="translate(-134 -568)">
									<path id="Polygon_2" data-name="Polygon 2" d="M2,0,4,3H0Z" transform="translate(138 571) rotate(180)" fill="var(--white)" />
								</g>
							</svg>
						</span>
							<dt style="display: flex; align-items: center; justify-content: space-between; padding-right: 15px;">
								<button class="tablinks" style="flex-grow: 1; text-align: left;" @click="show_secondary_overview_market = !show_secondary_overview_market"  v-click-outside-element="closeSecondaryOverviewMarketSelector">{{ secondary_overview_market.name.toUpperCase() }}</button>
							</dt>
						<dd>
								<ul>
									<li v-for="overview_market in marketsStore.sportOverviewMarkets(preSportsStore.selected_esport_id)" :key="overview_market.slug" @click="selectSecondaryOverviewMarket(overview_market)" :class="secondary_overview_market.slug == overview_market.slug ? 'active' : ''" style="display: flex; justify-content: space-between; align-items: center; padding-right: 15px;">
										<button class="tablinks" style="flex-grow: 1; text-align: left;">{{ overview_market.name.toUpperCase() }}</button>
										<div class="live-fav-icon" style="cursor: pointer; padding-left: 10px; display: flex; align-items: center;" @click.stop="favouritesStore.toggleFavouriteOverviewMarket(preSportsStore.selected_esport_id, overview_market)">
											<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 12 11.143">
												<path :style="{ fill: favouritesStore.isOverviewFavourite(preSportsStore.selected_esport_id, overview_market) ? 'var(--primary)' : 'var(--tab-gray)' }" id="Icon_ionic-ios-star" data-name="Icon ionic-ios-star" d="M12.67,5.545H8.729l-1.2-3.573a.434.434,0,0,0-.814,0l-1.2,3.573H1.554a.43.43,0,0,0-.429.429.315.315,0,0,0,.008.072.412.412,0,0,0,.179.3L4.551,8.63,3.308,12.244a.43.43,0,0,0,.147.482.414.414,0,0,0,.241.1.525.525,0,0,0,.268-.1l3.161-2.253,3.161,2.253a.5.5,0,0,0,.268.1.385.385,0,0,0,.238-.1.425.425,0,0,0,.147-.482L9.7,8.63l3.212-2.3.078-.067a.449.449,0,0,0,.139-.287A.454.454,0,0,0,12.67,5.545Z" transform="translate(-1.125 -1.688)" />
											</svg>
										</div>
									</li>
								</ul>
						</dd>
					</dl>
				</div>
			</div> -->
		</div>

		<div class="live-tab-info competition-tab-main">
			<div id="competition" class="tab-content competetion-outer-main">

				<div class="live-info-outer" v-for="(date, date_index) in competition.dates" :key="date_index">
					<div class="live-info-inner">
						<div class="live-info-team">

							<div class="live-match competetion-date">
								<div class="live-match-name">
									<h3>{{ date_index }}</h3>
								</div>
							</div>

						</div>

						<!-- <div class="full-time-top top-title-dash">
							<template v-for="(odd, id) in primary_overview_market?.odd_names" :key="id">
								<span v-if="odd != ''">{{ odd }}</span>
							</template>
						</div> -->

						<!-- <div class="match-goal-top top-title-dash">
							<template v-for="(odd, id) in secondary_overview_market?.odd_names" :key="id">
								<span v-if="odd != ''">{{ odd }}</span>
							</template>
							<span class="bet-column-empty"></span>

						</div> -->

					</div>

					<!-- Fixtures -->
					<template v-for="fixture in date" :key="fixture.id">
						<template v-if=" initializeStore.screenWidth > 767">
							<div class="live-info-grid">
								<LiveFixtureDoubleMarket v-if="fixture.live"
									:primary_overview_market="primary_overview_market"
									:secondary_overview_market="secondary_overview_market"
									:fixture="fixture"
								/>

								<EsportFixtureDoubleMarket v-if="!fixture.live"
									:primary_overview_market="primary_overview_market"
									:secondary_overview_market="secondary_overview_market"
									:fixture="fixture"
								/>
							</div>
						</template>
						<template v-else>
							<LiveFixtureDoubleMarket v-if="fixture.live"
								:primary_overview_market="primary_overview_market"
								:secondary_overview_market="secondary_overview_market"
								:fixture="fixture"
							/>

							<EsportFixtureDoubleMarket v-if="!fixture.live"
								:primary_overview_market="primary_overview_market"
								:secondary_overview_market="secondary_overview_market"
								:fixture="fixture"
							/>
						</template>
					</template>
				</div>

			</div>

		</div>
		<!----- info tab start ------>

	</div>
</template>
<style scoped>
@media screen and (min-width: 320px) and (max-width: 767px) {
	.dropdown-option-top {
		display: block !important;
	}

	.dropdown-option-top-2 {
		display: none !important;
	}

}
</style>